import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
  Grid,
  Typography,
  MenuItem,
  Snackbar,
  Alert,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import Close icon
import axios from 'axios';
import env from "react-dotenv";

const EditProduct = ({ open, handleClose, fetchProducts, productData }) => {
  const [product, setProduct] = useState({
    product_code: '',
    product_name: '',
    // quantity: '',
    // daily_consumption: '',
    backup_time: '',
    base_uom: '',
    cost_per_unit: '',
    item_category: '',
    location: '',
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (productData) {
      setProduct({
        product_code: productData.product_code || '',
        product_name: productData.product_name || '',
        // quantity: productData.quantity || '',
        // daily_consumption: productData.daily_consumption !== undefined ? productData.daily_consumption : '',
        backup_time: productData.backup_time || '',
        base_uom: productData.base_uom || '',
        cost_per_unit: productData.cost_per_unit || '',
        item_category: productData.item_category || '',
        location: productData.location || '',
      });
    }
  }, [productData]);

  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    setLoading(true);
    axios
      .put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/${productData.id}`, product)
      .then((response) => {
        fetchProducts(); // Refetch the product list after update
        handleClose(); // Close the dialog
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error updating product:', error);
        setErrorMessage('Please enter all the required fields & then try again.');
        setLoading(false);
      });
  };

  const handleCloseSnackbar = () => {
    setErrorMessage('');
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
            Edit Raw Material
        </Typography>
        <IconButton onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
        </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <TextField
              label="Raw Material Code"
              name="product_code"
              variant="outlined"
              fullWidth
              margin="normal"
              value={product.product_code}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Raw Material Name"
              name="product_name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={product.product_name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
             <TextField
               select
               label="Item Category"
               name="item_category"
               variant="outlined"
               fullWidth
               value={product.item_category}
               onChange={handleChange}
             >
               <MenuItem value="">No selection</MenuItem> {/* Add this line for empty selection */}
               <MenuItem value="Raw Material">Raw Material</MenuItem>
               <MenuItem value="Consumable-Maintenance">Consumable-Maintenance</MenuItem>
               <MenuItem value="Consumable-Store">Consumable-Store</MenuItem>
               <MenuItem value="Consumable-Electrical">Consumable-Electrical</MenuItem>
             </TextField>
           </Grid>

            <Grid item xs={12}>
             <TextField
               select
               label="Location"
               name="location"
               variant="outlined"
               fullWidth
               value={product.location}
               onChange={handleChange}
             >
               <MenuItem value="">No selection</MenuItem> {/* Add this line for empty selection */}
               <MenuItem value="Rack 1">Rack 1</MenuItem>
               <MenuItem value="Rack 2">Rack 2</MenuItem>
               <MenuItem value="Rack 3">Rack 3</MenuItem>
               <MenuItem value="Rack 4">Rack 4</MenuItem>
             </TextField>
           </Grid>      

          {/* <Grid item xs={12} sm={6}>
            <TextField
              label="Quantity"
              name="quantity"
              variant="outlined"
              fullWidth
              margin="normal"
              type="number"
              value={product.quantity}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Daily Consumption"
              name="daily_consumption"
              variant="outlined"
              fullWidth
              margin="normal"
              type="number"
              value={product.daily_consumption}
              onChange={handleChange}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Cost Per Unit"
              name="cost_per_unit"
              type="number"
              variant="outlined"
              fullWidth
              margin="normal"
              value={product.cost_per_unit}
              onChange={handleChange}
            />
          </Grid>         
          <Grid item xs={12} sm={6}>
            <TextField
              label="Backup Time"
              name="backup_time"
              variant="outlined"
              fullWidth
              margin="normal"
              type="number"
              value={product.backup_time}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Base UOM"
              name="base_uom"
              variant="outlined"
              fullWidth
              margin="normal"
              value={product.base_uom}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleClose} color="secondary" disabled={loading}
        sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    }, }}
        >
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={loading}
          sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    },}} 
                    variant="contained"
        >
          {loading ? <CircularProgress size={24} /> : 'Save'}
        </Button>
      </DialogActions>
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

EditProduct.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  productData: PropTypes.object.isRequired,
};

export default EditProduct;
